
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import moment from 'moment';

import { Modal, Radio, Alert, Skeleton, notification, Flex, Card } from 'antd';

import { BACKEND_URL_QUOTATION } from 'Config/routes';

import { SmallInsuranceCard } from 'Pages/QuotationsComparatorPage/components/InsurancePackageCard';
import FormCreatePolice from './FormCreatePolice';


const ModalCreatePolice = (props) => {
  const {
    isVisible = false,
    onCloseModal,
    quotationId,
    aseguradoras,
    onSuccess,
    vendedores,
  } = props;

  const [stateQuotation, setStateQuotation] = useState({
    quotationData: {},
    selectedPackages: [],
    selectedPackage: null, // Paquete seleccionado por el cliente :)
  });
  const [isFetching, setIsFetching] = useState(false);
  const [messageError, setMessageError] = useState('');

  const formik = useFormik({
    initialValues: {
      vendedor: '',
      ramo: '',

      numero_poliza: null,
      fecha_inicio: moment(),
      fecha_fin: moment().add(365, 'days'),
      codio_objeto_asegurado: null,

      // Prima y comisiones
      prima: 0,
      gastos_expedicion: 0,
      iva: 0,
      total: 0,

      // porcentaje_iva_prima: 19,
      // editar_iva: false,
      // autocalcular_gastos_expedicion: false,
    },
    validate: (values) => {
      const errors = {};
      for (let fieldName in values) {
        if ([null, ''].includes(values[fieldName])) {
          errors[fieldName] = 'Campo requerido'
        }
      }

      // Validar que los números sean números
      const numberFields = ['prima', 'gastos_expedicion', 'iva', 'total'];
      for (let numberField of numberFields) {
        if (!(numberField in errors) && isNaN(values[numberField])) {
          errors[numberField] = 'Valor no válido'
        }
      }

      return errors;
    }
  });

  useEffect(() => {
    if (quotationId) {
      setIsFetching(true);
      setMessageError('');

      axios.get(`${BACKEND_URL_QUOTATION}${quotationId}/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem('token')}`,
        },
      })
        .then((response) => {
          setIsFetching(false);

          const selectedPackages = response.data.insurance_carrier_quotations.filter((item) => item.selected).map((item) => ({
            ...item,
            insuranceCarrierFiltered: aseguradoras.find((aseguradora) => aseguradora.id === item.insurance_carrier),
          }));

          // Filtrar en los paquetes para hallar el seleccionado por defecto
          const clienteSelectionPackage = selectedPackages.find((item) => item.client_preference);

          if (!selectedPackages.length) {
            setMessageError('Esta cotización no tiene paquetes seleccionados');
            return;
          }

          setStateQuotation({
            ...stateQuotation,
            quotationData: response.data,
            selectedPackages,
            selectedPackage: clienteSelectionPackage, // || selectedPackages[0],
          });

          const anualValue = clienteSelectionPackage?.payments.find((paiment) => paiment.id === 'ANUAL');

          const prima = ((anualValue?.value || 0) / 1.19).toFixed(2);

          formik.setValues({
            ...formik.values,
            numero_poliza: `Cotización - ${response.data.number}`,
            codio_objeto_asegurado: response.data.vehicle_data.placa,
            prima: prima,
            gastos_expedicion: 0,
            iva: ((anualValue?.value || 0) - prima).toFixed(2),
            total: (anualValue?.value || 0),
          });
        })
        .catch(({ response }) => {
          setIsFetching(false);
          setMessageError(response.data.message);
        });
    }
  }, [quotationId]);

  const handleSendModal = () => {
    if (!stateQuotation.selectedPackage) {
      setMessageError('Primero debes seleccionar un paquete');
      return;
    };

    if (!formik.isValid) return;

    setIsFetching(true);
    setMessageError('');

    axios.post(
      `${BACKEND_URL_QUOTATION}${quotationId}/crear_poliza/`, 
      {
        selected_package: stateQuotation.selectedPackage.id,
        ...formik.values,
        fecha_inicio: formik.values.fecha_inicio.format('YYYY-MM-DD'),
        fecha_fin: formik.values.fecha_fin.format('YYYY-MM-DD'),
      },
      {
        headers: {
          Authorization: `Token ${localStorage.getItem('token')}`,
        },
      }
    ).then(() => {
      notification.success({
        message: 'Póliza creada exitosamente',
        description: '',
      });
      setIsFetching(false);
      onSuccess();
    }).catch(({ response }) => {
      setIsFetching(false);
      setMessageError(response.data.message);
    });
  };

  const handleChangePackageSelection = (e) => {
    const newSelectedPackage = stateQuotation.selectedPackages.find((item) => item.id === e.target.value);
    setStateQuotation({
      ...stateQuotation,
      selectedPackage: newSelectedPackage,
    });
    const anualValue = newSelectedPackage.payments.find((paiment) => paiment.id === 'ANUAL');

    const prima = ((anualValue?.value || 0) / 1.19).toFixed(2);

    formik.setValues({
      ...formik.values,
      // Prima y comisiones
      prima: prima,
      gastos_expedicion: 0,
      iva: ((anualValue?.value || 0) - prima).toFixed(2),
      total: (anualValue?.value || 0),
    });
  };

  const modalContent = () => {
    if (isFetching) return <Skeleton active />;
    return (
      <Flex vertical gap='middle'>
        <Alert banner message="Creación de póliza" description="La póliza quedará pendiente por expedir" type="info" closable />
        {messageError && <Alert banner message={messageError} type="error" />}
        <Card style={{ overflow: 'hidden' }} styles={{ body: { overflow: 'auto' } }}>
          <Radio.Group
            onChange={handleChangePackageSelection}
            value={stateQuotation.selectedPackage ? stateQuotation.selectedPackage.id : null}
            block
            options={stateQuotation.selectedPackages.map(selectedPackage => ({
              value: selectedPackage.id,
              label: <SmallInsuranceCard
                insurancePackage={selectedPackage}
                onClose={false}
                insuranceCarrier={selectedPackage.insuranceCarrierFiltered}
              />
            }))}
          />
        </Card>
        {(stateQuotation.quotationData && stateQuotation.selectedPackage) && (<>
          <FormCreatePolice formController={formik} loading={isFetching} vendedores={vendedores} selectedPackage={stateQuotation.selectedPackage} />
        </>)}
      </Flex>
    );
  };

  return (
    <Modal
      width="60%"
      title={<p style={{ textAlign: 'center' }}>Crear póliza</p>}
      open={isVisible}
      onOk={handleSendModal}
      onCancel={onCloseModal}
      cancelText="Cancelar"
      okText="Crear póliza"
      cancelButtonProps={{ loading: isFetching }}
      okButtonProps={{ loading: isFetching }}
      closable={false}
    >
      {modalContent()}
    </Modal>
  );
};

ModalCreatePolice.defaultProps = {
  isVisible: false,
  onCloseModal: () => { },
  onSuccess: () => { },
};

ModalCreatePolice.propTypes = {
  isVisible: PropTypes.bool,
  onCloseModal: PropTypes.func,
  quotationId: PropTypes.string.isRequired,
  aseguradoras: PropTypes.array.isRequired,
  onSuccess: PropTypes.func,
  vendedores: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  aseguradoras: state.initialData.aseguradoras,
  vendedores: state.softsegurosVendedores.vendedores,
});

export default connect(mapStateToProps)(ModalCreatePolice);
